import {IElement} from '../../incase-domain/elements';
import {ELEMENT} from '../../incase-domain/elements/base/ElementTypes';
import {removeHtmlTagsAndSpacesAndReturnLength} from '../../incase-domain/utils/utils';
import useElementActions from '../../utils/hooks/slideUpdates/useElementActions';

export const useEmptyTextElementCleanup = (): ((element: IElement, index: number) => void) => {
    const {deleteElement} = useElementActions();

    return (element: IElement, index: number): void => {
        if (!element) return;
        if (element.type !== ELEMENT.STATIC_TEXT) return;
        if (removeHtmlTagsAndSpacesAndReturnLength(element.text) > 0) return;
        deleteElement(index);
    };
};
